<template>
    <div class="easyRestaurantManager-special-menu">
        <h2>{{ settings?.category_title }}</h2>
        <p>{{ settings?.category_short_desc }}</p>
        <div class="easyRestaurantManager-menu-categories">
            <div v-for="(category, index) in categories" :key="index" class="easyRestaurantManager-menu-category">
                <a href="#">
                    <div class="erm_category_img">
                        <img :alt="category.name" :src="imageUrl + category?.image" width="100" />
                    </div>
                    <p>{{ category.name }}</p>
                </a>
            </div>
        </div>
    </div>
    <div class="erm_classic_temp-menu">
        <div class="easyRestaurantManager-menu-title">
            <h2>{{ settings?.menus_title }}</h2>
            <p>{{ settings?.menus_short_desc }}</p>
        </div>
        <div class="erm_classic_temp-tabs">
            <span v-for="tab in tabs" :key="tab" :class="['erm_classic_temp-tab', { 'erm_classic_tem_active': tab === activeTab }]"
                @click="activeTab = tab">
                {{ tab }}
            </span>
        </div>
        <div class="erm_classic_temp-items">
            <div v-for="item in filteredMenuItems" :key="item.name" class="erm_classic_temp-item">
                <img :src="imageUrl + item?.image" :alt="item.name" class="erm_classic_temp-item-image" />
                <div class="erm_classic_temp-item-details" style="width: 100%;">
                    <div class="erm_classic_temp-item-title">
                        <h3>{{ item?.name }}</h3>
                        <hr>
                        <span class="erm_price">$26.00</span>
                    </div>
                    <p class="erm_classic_temp-item-description">{{ item.description }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        settings: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            imageUrl: window.RestaurantMenuMangeData.assets_url + '/images/',
            activeTab: 'Main Courses',
            tabs: ['Appetizers', 'Main Courses', 'Sides', 'Desserts'],
            categories: [
                {
                    name: "Appetizers",
                    image: "cat.jpg"
                },
                {
                    name: "Main Courses",
                    image: "cat.jpg"
                }
            ],
            menuItems: [
                { name: 'Fish Fry', category: 'Appetizers', description: 'Crispy, freshly made chips with rich, flavorful dips.', price: 26.00, image: 'cat.jpg' },
                { name: 'Pasta Alfredo', category: 'Main Courses', description: 'Creamy Alfredo pasta with a touch of herbs and spices.', price: 30.00, image: 'cat.jpg' },
                { name: 'Veg Biryani', category: 'Main Courses', description: 'Aromatic basmati rice cooked with fresh vegetables and spices.', price: 29.00, image: 'cat.jpg' },
            ]
        };
    },
    computed: {
        filteredMenuItems() {
            return this.menuItems.filter(item => item.category === this.activeTab);
        }
    }
};
</script>
